import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface FondCarteWithRef {
  content?: string;
  refCarte: number;
}
export interface ModeleCarteState {
  listeFondCarte?: FondCarteWithRef[];
  refCarte?: string;
}

const initialState: ModeleCarteState = {};

export const ModeleCarteSlice = createSlice({
  name: "@@app/modeleCarte",
  initialState: initialState,
  reducers: {
    setFondCarte: (
      state: ModeleCarteState,
      action: PayloadAction<FondCarteWithRef | undefined>
    ) => {
      if (action.payload) {
        state.listeFondCarte = state.listeFondCarte
          ? [...state.listeFondCarte, action.payload]
          : [action.payload];
      }
    },
  },
});

export const { setFondCarte } = ModeleCarteSlice.actions;

// Selectors
export const getFondCarte = (state): FondCarteWithRef[] | undefined =>
  state.modeleCarte && state.modeleCarte.listeFondCarte;
